export const allowModals = ["send-certificates"];
